module.exports = __webpack_public_path__ + "266ec9d3aeb46a973d58ba0d720ec5b0.svg";